export default {
  en: {
    // 页面标题和主要文案
    banner: {
      title1: "Accelerate AI Innovation",
      title2: "Schedule Global AI Computing Resources Efficiently",
      description:
        "Cycor focuses on AI large model full lifecycle resources and intelligent computing scheduling, with 30+ senior SA business enablement, helping enterprises break through model training/inference technical barriers, providing a one-stop AI infrastructure solution of 'AI Computing Infrastructure + Model Optimization + Industry LLM Customization'.",
      contactButton: "Contact Now",
    },

    // 数据展示
    data: {
      label1: "Senior SA Business Enablement",
      label2: "Avg. Cloud Cost Optimization",
      label3: "Developer Efficiency Boost",
    },

    // 合作伙伴
    partners: {
      title: "Leading LLMs & Cloud Providers",
    },

    // 解决方案
    solution: {
      title: "Cycor Solutions | One-Stop Cloud Problem Solver",
      problems: {
        procurement: {
          title: "Procurement Layer",
          issue1:
            "Multi-cloud price comparison is slow; procurement rules complex",
          issue2: "Vendor policies opaque; information gaps obvious",
        },
        usage: {
          title: "Usage Layer",
          utilization: "Resource Utilization",
          waste: "Idle Resource Waste",
        },
        operation: {
          title: "Operation Layer",
          issue1: "Permissions confused; compliance audits difficult",
          issue2: "Business setup takes 24+ hours to go live",
        },
      },
      content: {
        subtitle: "Intelligent Multi-Cloud Management",
        title:
          'Solve "Hard to Choose Cloud, Expensive to Use" and Boost Efficiency',
        description:
          "Cycor manages cloud lifecycle with multi-cloud procurement, cost transparency, and automated operations.",
        cards: {
          procurement: "One-Stop Cloud Procurement",
          devfinops: "DevFinOps Cost Reduction",
          learnMore: "Learn More",
          action: "Learn Now",
        },
      },
    },

    aiSolution: {
      tag: "Full Lifecycle AI Resource Scheduling",
      title: "Integrated LLM Inference Solution",
      description:
        "Focused on LLM inference, AI computing resources and engineering scheduling, providing a one-stop AI infrastructure solution of 'AI Computing + Model Optimization + Industry LLM Customization', helping enterprises overcome inference cost and stability barriers, with traceable usage and internal cost settlement.",
      card1: "Unified Access & Production-Grade Inference",
      card2: "Internal Cost Attribution & AI Engineering Delivery",
      learnMore: "Learn Now",
      btnMore: "Learn More",
    },

    // 客户案例
    cases: {
      title: "Trusted Choice of Leading Global Enterprises",
      types: {
        manufacturing: "Manufacturing | Digital Transformation",
        consumer: "Consumer Goods | Global Expansion",
        service: "Service Provider | Cloud Cost Optimization",
      },
      tags: {
        challenge: "Challenge",
        solution: "Solution",
        results: "Results",
      },
      manufacturing: {
        challenge:
          "Expanding to Europe faced strict compliance and high IT O&M costs, lacking AI-driven fault detection experience.",
        solution:
          "Delivered end-to-end solutions: cloud migration, compliance, and AI-powered process optimization.",
        results: {
          compliance: {
            title: "Compliance:",
            desc: "Built data architecture meeting European regulations.",
          },
          innovation: {
            title: "Accelerated Innovation:",
            desc: "Improved development and deployment speed, enabling fast market response.",
          },
          intelligence: {
            title: "Intelligent Operations:",
            desc: "AI optimized complex business solution paths.",
          },
        },
        resultTitle: {
          h1: "Compliant Cloud Architecture",
          h2: "Enabling Efficient Global Expansion",
        },
      },
      consumer: {
        challenge:
          "Rapid global growth challenged IT stability, security, and user experience.",
        solution:
          "Built global cloud with 99.99% uptime, multi-language H5 apps, and serverless auto-scaling.",
        results: {
          reliability: {
            title: "Stability:",
            desc: "Ensured 99.99% availability for core business.",
          },
          experience: {
            title: "Global Experience:",
            desc: "Delivered smooth, consistent mobile experience worldwide.",
          },
          security: {
            title: "Data Security:",
            desc: "Established secure, compliant global payment system.",
          },
        },
        resultTitle: {
          h1: "High-Availability Cloud Foundation",
          h2: "Supporting Global Coffee Brand Expansion",
        },
      },
      service: {
        challenge:
          "Advertising platform with 230B+ daily requests needed to control traffic costs while ensuring stability.",
        solution:
          "Deployed multi-cloud with elastic resources, networking, and observability to cut costs.",
        results: {
          cost: {
            title: "Cost Savings:",
            desc: "Reduced peak traffic bandwidth costs via efficient scheduling.",
          },
          stability: {
            title: "Stable Operation:",
            desc: "Met high-concurrency demands, ensuring 24/7 business continuity.",
          },
          efficiency: {
            title: "Operational Efficiency:",
            desc: "Minute-level fault detection improved response speed.",
          },
        },
        resultTitle: {
          h1: "High-Concurrency Ad Platform",
          h2: "Balancing Cost and Performance with Multi-Cloud",
        },
      },
      buttons: {
        consultExpert: "Book Expert Consultation",
        viewAll: "View All Cases",
      },
    },

    // 认证资质
    certificates: {
      title: "Our Expertise, Recognized by the Industry",
      items: {
        cert1: {
          title: "AWS<br />Advanced Partner",
          alt: "AWS Advanced Partner",
        },
        cert2: {
          title: "AWS Generative<br />AI Competency",
          alt: "AWS Generative AI Competency",
        },
        cert3: {
          title: "AWS Migration &<br />Modernization Competency",
          alt: "AWS Migration & Modernization Competency",
        },
        cert4: {
          title: "Google Cloud<br />Partner",
          alt: "Google Cloud Partner",
        },
        cert5: {
          title: "Oracle<br />Partner Network Member",
          alt: "Oracle Partner Network Member",
        },
        cert6: {
          title: "Alibaba Cloud<br />Channel Partner",
          alt: "Alibaba Cloud Channel Partner",
        },
        cert7: {
          title: "Kubernetes<br />Certified Administrator",
          alt: "Kubernetes Certified Administrator",
        },
        cert8: {
          title: "AWS Certified<br />Solutions Architect Professional",
          alt: "AWS Certified Solutions Architect Professional",
        },
        cert9: {
          title: "Google Cloud<br />Professional Cloud Architect",
          alt: "Google Cloud Professional Cloud Architect",
        },
        cert10: {
          title: "2024 CHINA<br />AIGC100",
          alt: "2024 CHINA AIGC100",
        },
      },
    },

    // 优势展示
    advantages: {
      title: "Why Choose Us?",
      items: {
        cost: {
          title: "Significant Cost Savings",
          description:
            "We provide cloud resource prices below market average, making every budget you spend more valuable.",
        },
        convenience: {
          title: "Ultimate Procurement Convenience",
          description:
            "One partner manages all major clouds with flexible payments, eliminating complex processes.",
        },
        experience: {
          title: "Deep Industry Accumulation",
          description:
            "Cycor is a brand under eclicktech (SZ301171), backed by more than ten years of enterprise internationalization service experience.",
        },
        service: {
          title: "Professional Service Guarantee",
          description:
            "We not only provide products, but also provide 7x24 hour expert team services, responding to any of your needs at any time.",
        },
      },
      contactButton: "Contact Us",
    },
  },
  zh: {
    // 页面标题和主要文案
    banner: {
      title1: "加速AI创新突破",
      title2: "高效调度全球智算资源",
      description:
        "Cycor 聚焦AI大模型全生命周期资源与智算调度，30+资深SA业务赋能，助力企业突破「模型训练/推理」技术壁垒，提供「智算基建+模型优化+行业大模型定制」一站式AI基础设施解决方案。",
      contactButton: "立即联系",
    },

    // 数据展示
    data: {
      label1: "资深SA业务赋能",
      label2: "平均云成本优化率",
      label3: "开发人员效率提升",
    },

    // 合作伙伴
    partners: {
      title: "主流大模型与云厂商",
    },

    // 解决方案
    solution: {
      title: "Cycor 解决方案｜ 一站式解决您的云端难题",
      problems: {
        procurement: {
          title: "采购层",
          issue1: "多云比价耗时，采购员规则繁琐",
          issue2: "厂商政策不透明，信息差问题突出",
        },
        usage: {
          title: "使用层",
          utilization: "资源利用率：",
          waste: "闲置资源浪费：",
        },
        operation: {
          title: "运维层",
          issue1: "权限混乱，合规审计难",
          issue2: "业务配置上线超24小时",
        },
      },
      content: {
        subtitle: "智能化多云管理",
        title: '破解"选云难、用云贵"困局, 驱动云效跃迁',
        description:
          '当云计算成为企业IT架构的基础设施，企业不再纠结于是否上云，而是更关注所选云厂商是否能够提供更高性价比、更强稳定性以及更完善售后服务。Cycor智能化多云管理，覆盖云资源使用全生命周期，可为企业提供针对多家云厂商、多种云资源的一站式采购及管理解决方案，助力企业破解"选云难、用云贵"困局，轻松实现云支出透明化、资源效率最大化、运维响应自动化。',
        cards: {
          procurement: "一站式云采购解决方案",
          devfinops: "DevFinOps多云降本解决方案",
          learnMore: "了解更多",

          action: "立即了解",
        },
      },
    },

    aiSolution: {
      tag: "大模型与智算全生命周期资源调度",
      title: "AI 大模型推理一体化解决方案",
      description:
        "聚焦大模型推理、智算资源与工程化调度，提供「智算基建 + 模型优化 + 行业模型定制」一站式智算基础设施方案，服务企业突破推理成本与稳定性壁垒，并让用量与对内结算可追溯。",
      card1: "统一接入与生产级推理保障",
      card2: "对内成本归因与智算工程化交付",
      learnMore: "立即了解",
      btnMore: "了解更多",
    },

    // 客户案例
    cases: {
      title: "全球领先企业的信赖之选",
      types: {
        manufacturing: "制造业｜数字化转型解决方案",
        consumer: "消费品｜出海解决方案",
        service: "服务商｜云上降本解决方案",
      },
      tags: {
        challenge: "业务挑战",
        solution: "解决方案",
        results: "关键成果",
      },
      manufacturing: {
        challenge:
          "拓展欧洲市场时，面临严苛的数据合规要求与高昂的IT运维成本，缺乏利用AI提升设备故障检测效率的经验。",
        solution:
          "我们为其提供了端到端的解决方案，完成IT架构向公有云的整体迁移，提升灵活性。提供专业的合规咨询服务，保障数据架构安全合规。引入智能化AI应用，重塑并优化核心业务流程。",
        results: {
          compliance: {
            title: "业务出海合规：",
            desc: "成功构建了符合欧洲当地法规的数据架构。",
          },
          innovation: {
            title: "加速业务创新：",
            desc: "应用开发与部署速度显著提升，能快速响应市场变化。",
          },
          intelligence: {
            title: "实现智能运维：",
            desc: "通过AI赋能，有效优化了复杂业务的解决路径。",
          },
        },
        resultTitle: {
          h1: "构建合规云架构",
          h2: "赋能能源巨头高效出海",
        },
      },
      consumer: {
        challenge:
          "全球化业务的极速扩张，对IT基础设施的稳定性、安全性与全球用户体验提出了巨大挑战。",
        solution:
          "我们为其构建了全新的全球云基础设施，将核心业务数据库平滑迁移至99.99%高可用的云上环境。开发了支持16种语言、并能在多终端自适应显示的H5应用。利用无服务器计算能力，自动化处理高并发场景。",
        results: {
          reliability: {
            title: "业务稳定可靠：",
            desc: "为核心业务提供了高达99.99%的可用性保障。",
          },
          experience: {
            title: "全球体验一致：",
            desc: "确保了全球顾客流畅、一致的移动端点单体验。",
          },
          security: {
            title: "数据支付安全：",
            desc: "建立了满足全球运营需求的安全合规的支付体系。",
          },
        },
        resultTitle: {
          h1: "以高可用云基座",
          h2: "支撑全球咖啡品牌极速扩张",
        },
      },
      service: {
        challenge:
          "作为日均处理超2300亿次请求的广告平台，如何在确保系统稳定性的同时，有效控制高昂的流量带宽成本。",
        solution:
          "我们为其设计并部署了先进的多云方案，实施跨云平台的弹性资源调度与内网组网。搭建全链路可观测系统，实现分钟级的故障告警与定位。简化中间件调用路由，从架构层面降低流量成本。",
        results: {
          cost: {
            title: "大幅降低成本：",
            desc: "通过高效调度，显著节省了高峰期的流量带宽成本。",
          },
          stability: {
            title: "系统稳定运行：",
            desc: "成功满足高并发业务的弹性需求，保障业务7x24不中断。",
          },
          efficiency: {
            title: "运维效率提升：",
            desc: "实现了分钟级的故障定位能力，极大提升了响应速度。",
          },
        },
        resultTitle: {
          h1: "为高并发广告平台",
          h2: "打造兼顾成本与性能的多云方案",
        },
      },
      buttons: {
        consultExpert: "预约专家咨询",
        viewAll: "查看全部案例",
      },
    },

    // 认证资质
    certificates: {
      title: "我们的专业，业界共睹",
      items: {
        cert1: {
          title: "AWS<br />高级合作伙伴",
          alt: "AWS 高级合作伙伴",
        },
        cert2: {
          title: "AWS生成式<br />AI服务能力认证",
          alt: "AWS生成式AI服务能力认证",
        },
        cert3: {
          title: "AWS迁移与现代化<br />服务能力认证",
          alt: "AWS迁移与现代化服务能力认证",
        },
        cert4: {
          title: "谷歌云<br />合作伙伴",
          alt: "谷歌云合作伙伴",
        },
        cert5: {
          title: "甲骨文<br />合作伙伴网络成员",
          alt: "甲骨文合作伙伴网络成员",
        },
        cert6: {
          title: "阿里云<br />渠道合作伙伴",
          alt: "阿里云渠道合作伙伴",
        },
        cert7: {
          title: "Kubernetes<br />认证管理员",
          alt: "Kubernetes认证管理员",
        },
        cert8: {
          title: "AWS<br />认证解决方案架构师专业级",
          alt: "AWS认证解决方案架构师专业级",
        },
        cert9: {
          title: "谷歌云<br />认证专业级云架构师",
          alt: "谷歌云认证专业级云架构师",
        },
        cert10: {
          title: "非凡产研<br />2024 CHINA AIGC100",
          alt: "2024 CHINA AIGC100",
        },
      },
    },

    // 优势展示
    advantages: {
      title: "为什么选择我们？",
      items: {
        cost: {
          title: "显著的成本节约",
          description:
            "我们提供低于市场平均水平的云资源价格，让您的每一分预算都花得更有价值。",
        },
        convenience: {
          title: "极致的采购便捷",
          description:
            "一个合作伙伴，即可采购所有主流云，还可享受更灵活的支付方式，告别繁琐流程。",
        },
        experience: {
          title: "深厚的行业积淀",
          description:
            "Cycor 是易点天下（SZ301171）旗下品牌，背靠十余年企业国际化服务经验。",
        },
        service: {
          title: "专业的服务保障",
          description:
            "我们不仅提供产品，更提供 7x24 小时的专家团队服务，随时响应您的任何需求。",
        },
      },
      contactButton: "联系我们",
    },
  },

  ja: {
    // 页面标题和主要文案
    banner: {
      title1: "AIイノベーションを加速",
      title2: "グローバル智算リソースを<br />効率的にスケジューリング",
      description:
        "CycorはAI大モデルのフルライフサイクルリソースと智算スケジューリングに注力し、30+名のシニアSAが企業のモデルトレーニング/推論の技術障壁突破を支援し、「智算基盤+モデル最適化+業界LLMカスタマイズ」の一体型AIインフラソリューションを提供します。",
      contactButton: "お問い合わせ",
    },

    // 数据展示
    data: {
      label1: "シニアSAビジネスイネーブルメント",
      label2: "平均クラウドコスト最適化率",
      label3: "開発者効率向上",
    },

    // 合作伙伴
    partners: {
      title: "主流LLMとクラウド事業者",
    },

    // 解决方案
    solution: {
      title: "Cycorソリューション | クラウドの課題をワンストップで解決",
      problems: {
        procurement: {
          title: "調達レイヤー",
          issue1: "マルチクラウド価格比較に時間がかかり、調達ルールが複雑",
          issue2: "ベンダーポリシーが不透明で、情報格差が顕著",
        },
        usage: {
          title: "使用レイヤー",
          utilization: "リソース使用率：",
          waste: "アイドルリソースの無駄：",
        },
        operation: {
          title: "運用レイヤー",
          issue1: "権限の混乱、コンプライアンス監査の困難",
          issue2: "ビジネス設定のオンライン化に24時間以上",
        },
      },
      content: {
        subtitle: "インテリジェントマルチクラウド管理",
        title:
          "「クラウド選択の困難、クラウド使用の高コスト」のジレンマを解決し、クラウド効率の飛躍を推進",
        description:
          "クラウドが企業ITの基盤となる中、Cycorはリソース全ライフサイクルを管理し、ワンストップで調達・支出透明化・効率最大化・運用自動化を支援します。",
        cards: {
          procurement: "ワンストップクラウド調達ソリューション",
          devfinops: "DevFinOpsマルチクラウドコスト削減ソリューション",
          learnMore: "詳細を見る",
          action: "今すぐ学ぶ",
        },
      },
    },

    aiSolution: {
      tag: "大規模モデルと智算の全ライフサイクルリソーススケジューリング",
      title: "AI 大規模モデル推論一体型ソリューション",
      description:
        "大規模モデル推論、智算リソースとエンジニアリングスケジューリングに注力し、「智算インフラ + モデル最適化 + 業界LLMカスタマイズ」の一体型AIインフラソリューションを提供し、推論コストと安定性の障壁を突破し、使用量と社内決済を追跡可能にします。",
      card1: "統合アクセスと本番グレード推論保証",
      card2: "社内コスト帰属と智算エンジニアリング納品",
      learnMore: "今すぐ学ぶ",
      btnMore: "詳細を見る",
    },

    // 客户案例
    cases: {
      title: "グローバル有力企業の信頼の選択",
      types: {
        manufacturing: "製造業｜デジタル変革ソリューション",
        consumer: "消費財｜海外展開ソリューション",
        service: "サービスプロバイダー｜クラウドコスト削減ソリューション",
      },
      tags: {
        challenge: "ビジネス課題",
        solution: "ソリューション",
        results: "主要成果",
      },
      manufacturing: {
        challenge:
          "ヨーロッパ市場への拡大時に、厳しいデータコンプライアンス要件と高いIT運用・保守コストに直面し、AIを活用した設備故障検出効率向上の経験が不足していました。",
        solution:
          "ITをパブリッククラウドへ移行し柔軟性を向上。コンプライアンス対応とAI活用でコア業務を最適化しました。",
        results: {
          compliance: {
            title: "ビジネス海外展開コンプライアンス：",
            desc: "ヨーロッパ現地法規に適合するデータアーキテクチャの構築に成功しました。",
          },
          innovation: {
            title: "ビジネスイノベーションの加速：",
            desc: "アプリケーション開発・デプロイメント速度が大幅に向上し、市場変化に迅速に対応できるようになりました。",
          },
          intelligence: {
            title: "インテリジェント運用の実現：",
            desc: "AIの力により、複雑なビジネスのソリューションパスを効果的に最適化しました。",
          },
        },
        resultTitle: {
          h1: "パブリッククラウドへの全体移行",
          h2: "エネルギー巨人の欧州市場進出を支援",
        },
      },
      consumer: {
        challenge:
          "グローバルビジネスの急速な拡大により、ITインフラストラクチャの安定性、セキュリティ、グローバルユーザーエクスペリエンスに対する巨大な課題が生まれました。",
        solution:
          "グローバルクラウド基盤を構築し、データベースを99.99%高可用性で移行。多言語H5アプリを開発し、サーバーレスで高並行処理を自動化しました。",
        results: {
          reliability: {
            title: "ビジネスの安定性と信頼性：",
            desc: "コアビジネスに最大99.99%の可用性保障を提供しました。",
          },
          experience: {
            title: "一貫したグローバルエクスペリエンス：",
            desc: "グローバル顧客にスムーズで一貫したモバイル端末体験を確保しました。",
          },
          security: {
            title: "データ決済セキュリティ：",
            desc: "グローバル運営ニーズを満たすセキュアでコンプライアントな決済システムを構築しました。",
          },
        },
        resultTitle: {
          h1: "高可用クラウド基盤で",
          h2: "グローバルコーヒーブランドの急速拡大を支え",
        },
      },
      service: {
        challenge:
          "日平均2300億回以上のリクエストを処理する広告プラットフォームとして、システムの安定性を確保しながら、高額なトラフィック帯域幅コストを効果的に制御する方法。",
        solution:
          "マルチクラウドを展開し、弾性リソース管理とネットワーク最適化を実施。フルリンク観測で迅速障害対応、ミドルウェア簡素化でトラフィックコストを削減しました。",
        results: {
          cost: {
            title: "大幅なコスト削減：",
            desc: "効率的なスケジューリングにより、ピーク時のトラフィック帯域幅コストを大幅に節約しました。",
          },
          stability: {
            title: "システムの安定稼働：",
            desc: "高並行性ビジネスの弾性ニーズを成功裏に満たし、7x24のビジネス無中断を保障しました。",
          },
          efficiency: {
            title: "運用効率の向上：",
            desc: "分レベルの障害位置特定能力を実現し、対応速度を大幅に向上させました。",
          },
        },
        resultTitle: {
          h1: "マルチクラウドを展開し",
          h2: "コスト効率と性能を両立",
        },
      },
      buttons: {
        consultExpert: "エキスパート相談予約",
        viewAll: "すべてのケースを見る",
      },
    },

    // 认证资质
    certificates: {
      title: "私たちの専門性、業界で認められています",
      items: {
        cert1: {
          title: "AWS<br />アドバンスドパートナー",
          alt: "AWS アドバンスドパートナー",
        },
        cert2: {
          title: "AWS生成式<br />AIコンピテンシー",
          alt: "AWS生成式AIコンピテンシー",
        },
        cert3: {
          title: "AWSマイグレーション&<br />モダナイゼーションコンピテンシー",
          alt: "AWSマイグレーション&モダナイゼーションコンピテンシー",
        },
        cert4: {
          title: "Google Cloud<br />パートナー",
          alt: "Google Cloudパートナー",
        },
        cert5: {
          title: "Oracle<br />パートナーネットワークメンバー",
          alt: "Oracleパートナーネットワークメンバー",
        },
        cert6: {
          title: "Alibaba Cloud<br />チャネルパートナー",
          alt: "Alibaba Cloudチャネルパートナー",
        },
        cert7: {
          title: "Kubernetes<br />認定管理者",
          alt: "Kubernetes認定管理者",
        },
        cert8: {
          title: "AWS認定<br />ソリューションアーキテクトプロフェッショナル",
          alt: "AWS認定ソリューションアーキテクトプロフェッショナル",
        },
        cert9: {
          title: "Google Cloud<br />プロフェッショナルクラウドアーキテクト",
          alt: "Google Cloudプロフェッショナルクラウドアーキテクト",
        },
        cert10: {
          title: "2024 CHINA<br />AIGC100",
          alt: "2024 CHINA AIGC100",
        },
      },
    },

    // 优势展示
    advantages: {
      title: "なぜ私たちを選ぶのか？",
      items: {
        cost: {
          title: "大幅なコスト節約",
          description:
            "市場平均を下回るクラウドリソース価格を提供し、お客様のすべての予算をより価値のあるものにします。",
        },
        convenience: {
          title: "究極の調達利便性",
          description:
            "一つのパートナーで、すべての主流クラウドを調達でき、より柔軟な支払い方法を享受し、煩雑なプロセスとお別れできます。",
        },
        experience: {
          title: "深い業界蓄積",
          description:
            "CycorはClickLink（SZ301171）傘下のブランドで、10年以上の企業国際化サービス経験に支えられています。",
        },
        service: {
          title: "専門的なサービス保障",
          description:
            "私たちは製品を提供するだけでなく、7x24時間の専門チームサービスを提供し、お客様のあらゆるニーズにいつでも対応します。",
        },
      },
      contactButton: "お問い合わせ",
    },
  },
};
